import { Component, ElementRef, ErrorHandler, inject, Input, Renderer2, ViewEncapsulation } from '@angular/core';
import { BrIconRegistry } from './icon-registry.service';

/** Existing font glyphs and registered static SVGs, without Angular Material. */
@Component({
  selector: 'br-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.css'],
  // SVG nodes are created by the registry, so their styles cannot depend on
  // Angular's template-only encapsulation attributes. All rules target br-icon.
  encapsulation: ViewEncapsulation.None,
  host: { 'role': 'img', 'class': 'br-icon notranslate' },
})
export class BrIconComponent {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private readonly renderer = inject(Renderer2);
  private readonly registry = inject(BrIconRegistry);
  private readonly errors = inject(ErrorHandler);
  private svg?: SVGElement;

  constructor() {
    if (!this.element.hasAttribute('aria-hidden')) this.renderer.setAttribute(this.element, 'aria-hidden', 'true');
  }

  @Input() set svgIcon(value: string | null | undefined) {
    if (this.svg) { this.renderer.removeChild(this.element, this.svg); this.svg = undefined; }
    if (!value) return;
    const colon = value.indexOf(':');
    const namespace = colon < 0 ? '' : value.slice(0, colon);
    const name = colon < 0 ? value : value.slice(colon + 1);
    // This registry only returns synchronous static clones; it never fetches.
    this.registry.getNamedSvgIcon(name, namespace).subscribe({
      next: svg => { this.svg = svg; this.renderer.appendChild(this.element, svg); },
      error: error => this.errors.handleError(error),
    });
  }
}
